import { render, staticRenderFns } from "./StadiumLocation.vue?vue&type=template&id=27481998"
import script from "./StadiumLocation.vue?vue&type=script&lang=js"
export * from "./StadiumLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports